import {useEffect} from 'react'
import {useOrganization} from 'organization/OrganizationProvider'
import {useEvent} from 'Event/EventProvider'
import {useEventMarketplaceClient} from 'lib/marketplace-api/use-event-marketplace-client'
import {useUpsellPage} from 'lib/marketplace-api/upsell-page/use-upsell-page'
import {useCreateUpsellPage} from 'lib/marketplace-api/upsell-page/use-create-upsell-page'

export default function useAutoCreateUpsellPage() {
  const {event} = useEvent()
  const {organization} = useOrganization()
  const {client} = useEventMarketplaceClient()

  const {
    data: upsellPage,
    isLoading,
    isSuccess: fetchedUpsellPage,
  } = useUpsellPage({
    event,
  })

  const createUpsellPage = useCreateUpsellPage({
    organization,
    event,
  })

  useEffect(() => {
    if (
      !fetchedUpsellPage ||
      upsellPage ||
      createUpsellPage.isLoading ||
      !client
    ) {
      return
    }

    createUpsellPage.mutate({client})
  }, [fetchedUpsellPage, upsellPage, createUpsellPage, client])

  if (isLoading) {
    return {
      isLoading,
      upsellPage: undefined,
    }
  }

  return {
    isLoading,
    upsellPage: upsellPage,
  }
}
